export const formatCurrency = (value) =>
  new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(value);

export const formatNumber = (value) => new Intl.NumberFormat('id-ID').format(value);

export const formatPercentage = (value) => `${value.toFixed(2)}%`;
